const getAccess = (
  permissions,
  permissionGroups,
  functionToAccess,
  methodToAccess
) => {
  const directPermissionMatch = permissions?.filter(
    (el) =>
      el?.function?.localeCompare(functionToAccess) === 0 &&
      el?.method?.localeCompare(methodToAccess) === 0
  ).length > 0;

  const groupPermissionMatch = permissionGroups?.filter(
    (el) =>
      el?.function?.localeCompare(functionToAccess) === 0 &&
      el?.method?.localeCompare(methodToAccess) === 0
  ).length > 0;

  const hasAccess = directPermissionMatch || groupPermissionMatch;

  return hasAccess;
};
export default getAccess;
